module.exports = __webpack_public_path__ + "static/media/census-vertical.b42b6fc1.jpg";